// src/components/ErrorBoundary.tsx

import ErrorFallback, { ErrorFallbackProps } from "./ErrorFallback";

import React from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  FallbackComponent: React.ComponentType<ErrorFallbackProps>;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {

  return (
    <ReactErrorBoundary FallbackComponent={ErrorFallback}
      onReset={(details) => {
        // Reset the state of your app so the error doesn't happen again
      }}
      >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
